module.exports = __webpack_public_path__ + "img/baseline_select@2x.5e91a539.svg";